import { IDealerWorkingDay } from '@/interfaces/dealers.interfaces';
import deepCopy from '@/utils/deepCopy';

export interface IWorkTimeInterval {
  days: string;
  time: string;
}

export interface ITemporaryInterval {
  days: Array<number>;
  time: string;
}

const MAPPINGS: Record<number, string> = {
  0: 'пн',
  1: 'вт',
  2: 'ср',
  3: 'чт',
  4: 'пт',
  5: 'сб',
  6: 'вс',
};

const getWorkTimeTitle = (workDay: number): string | undefined => {
  return MAPPINGS[workDay];
};

const formatTime = (dateString: string) => {
  const date = new Date(dateString);

  return date.toLocaleTimeString('ru-RU', {
    hour: '2-digit',
    minute: '2-digit',
    timeZone: 'UTC',
  });
};

const getDealerWorkTime = (days?: Array<IDealerWorkingDay>): Array<IWorkTimeInterval> => {
  if (days) {
    const intervals: Array<IWorkTimeInterval> = [];
    const temporary: Array<ITemporaryInterval> = [];

    let currentInterval: ITemporaryInterval | undefined;
    let prevTime = '';
    let prevWeekDay = 0;

    const formattedDays = days.map(day => {
      if (!day.from || !day.to) {
        return day;
      }
      return {
        ...day,
        from: formatTime(day.from),
        to: formatTime(day.to),
      };
    });

    for (const day of formattedDays) {
      let time = 'Выходной';

      if (day.isWorkday && !!day.from && !!day.to) {
        time = `${day.from} - ${day.to}`;
      }

      if (!currentInterval) {
        currentInterval = {
          days: [day.weekday],
          time,
        };
      } else {
        const weekDaysAreInLine = prevWeekDay + 1 === day.weekday;
        const timeAreSame = prevTime === time;

        if (!weekDaysAreInLine || !timeAreSame) {
          temporary.push(deepCopy(currentInterval));

          currentInterval = {
            days: [day.weekday],
            time,
          };
        } else {
          currentInterval.days.push(day.weekday);
        }
      }

      prevWeekDay = day.weekday;
      prevTime = time;
    }

    if (currentInterval) {
      temporary.push(currentInterval);
    }

    for (const t of temporary) {
      let intervalDays: string | undefined;

      if (t.days.length > 1) {
        const from = getWorkTimeTitle(t.days[0]);
        const to = getWorkTimeTitle(t.days[t.days.length - 1]);

        if (!!from && !!to) {
          intervalDays = `${from} - ${to}`;
        }
      } else {
        intervalDays = getWorkTimeTitle(t.days[0]);
      }

      if (!intervalDays) {
        continue;
      }

      intervals.push({
        days: intervalDays,
        time: t.time,
      });
    }

    return intervals;
  }

  return [];
};

export { getWorkTimeTitle };

export default getDealerWorkTime;
